import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../St/Reports/UseStyle';
import { tableLayouts } from "pdfmake/build/pdfmake";
export default function TawlaForm(props) {
    const {
        AutoOptions,
        rptParams,
        rptParamsAuto,
        onChangeAutoData,
        changTField,
        isGroups,
        typeTwala
    } = props;

    const { t } = useTranslation(["forms"]);
    const clasAo = useStylesAuto();

    const clasup = useStylesUp();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={4} md={4} sm={4} xs={3} style={{ marginBottom: "0.5rem" }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="id"

                        label={isGroups ? t("session-no") : t("table-no")}
                        //className={clasTF.clrBlack}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        // InputProps={{ className: clasTD.input, readOnly: true }}
                        type="text"
                        name="id"
                        value={rptParams.id}
                    />
                </Grid>
                <Grid item lg={8} md={8} sm={8} xs={9} style={{ marginBottom: "0.5rem" }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={isGroups ? t("session-name") : t("table-name")}
                        type="text"
                        name="name"
                        value={rptParams.Name}
                        InputLabelProps={{
                            className: claslbl.clrBlackLblS,

                        }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("Name")}
                    />
                </Grid>
                {isGroups ?
                    (
                        <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                            <Autocomplete classes={clasAo}
                                value={rptParamsAuto?.Type}
                                onChange={(event, newValue) => {
                                    onChangeAutoData("Type", newValue);
                                }}
                                id="combo-box-demo"
                                size="small"
                                options={typeTwala}
                                getOptionLabel={(option) =>
                                    typeof option === "string" ? option : option?.name
                                }
                                style={{}}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                        label={t("group")}
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                    ) :
                    (
                        <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                            <Autocomplete classes={clasAo}
                                value={rptParamsAuto?.tawla_group}
                                onChange={(event, newValue) => {
                                    //   setBranch(newValue);
                                    onChangeAutoData("tawla_group", newValue);

                                }}
                                id="combo-box-demo"
                                size="small"
                                options={AutoOptions?.tawla_group??[]}
                                getOptionLabel={(option) =>
                                    typeof option === "string" ? option : option?.Name
                                }
                                style={{}}
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                        label={t("session")}
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                    )}
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto.branch}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("branch", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("branch")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>


            </Grid>
        </React.Fragment>
    );
}
